export const GenderData = [
  {
    label: "男",
    value: 1,
  },
  {
    label: "女",
    value: 0,
  },
];
export const childrenVal = (data, obj) => {
  data.length > 0 &&
    data.map((item) => {
      item.value = item[obj[0]];
      item.label = item[obj[1]];
      if (item.children && item.children.length > 0) {
        childrenVal(item.children, obj);
      }
    });
  return data;
};
export const formInputData = [
  {
    name: "工作单位",
    type: "userOrganization",
    reg: "",
    errorText: "",
  },
  {
    name: "邮政编码",
    type: "postCode",
    reg: /^[1-9]\d{5}(?!\d)$/,
    errorText: "请输入正确的邮政编码",
  },
  {
    name: "电子邮箱",
    type: "emailAddress",
    reg: /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/,
    errorText: "请输入正确的电子邮箱",
  },
  {
    name: "户口所在地",
    type: "regAddress",
    reg: "",
    errorText: "",
  },
  {
    name: "通讯地址",
    type: "contactAddress",
    reg: "",
    errorText: "",
  },
  {
    name: "固定电话",
    type: "homeNumber",
    reg: /^\d{3,4}-\d{7,8}$/,
    errorText: "请输入正确的固定电话",
  },
];
